export default "__VITE_ASSET__CuaDLOJd__"